import {
    getWindowObject,
    HAS_WINDOW_LISTENERS,
} from '@eventbrite/feature-detection';
import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import type { Event } from '../../../../types/index';
import './TicketSelectionIframe.scss';

export type TicketSelectionIframeProps = Pick<Event, 'id'>;

export const TICKET_SELECTION_CONTAINER_ID =
    'ticket-selection-iframe-container';
const COMPACT_CHECKOUT_PARAMS = { name: 'ticketsPageSize', value: 'compact' };
const INITIAL_COMPONENT_HEIGHT = 204;

export const TicketSelectionIframe = ({ id }: TicketSelectionIframeProps) => {
    const [iframeWrapperHeight, setIframeWrapperHeight] = useState(
        INITIAL_COMPONENT_HEIGHT,
    );
    const [isTicketSelectionPage, setIsTicketSelectionPage] = useState(true);

    useEffect(() => {
        getWindowObject('EBWidgets').createWidget({
            widgetType: 'checkout',
            eventId: id,
            iframeContainerId: TICKET_SELECTION_CONTAINER_ID,
            extraParams: [COMPACT_CHECKOUT_PARAMS],
            iframeContainerHeight: iframeWrapperHeight,
        });

        HAS_WINDOW_LISTENERS &&
            window.addEventListener('message', _handlePostMessages);

        return () => {
            HAS_WINDOW_LISTENERS &&
                window.removeEventListener('message', _handlePostMessages);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useLayoutEffect(() => {
        const bodyTag = document.querySelector('body');
        if (bodyTag) {
            !isTicketSelectionPage
                ? bodyTag.classList.add('checkout-app-modal-opened')
                : bodyTag.classList.remove('checkout-app-modal-opened');
        }
    }, [isTicketSelectionPage]);

    const _handlePostMessages = (event: MessageEvent) => {
        const {
            data: {
                messageName,
                contentHeight = INITIAL_COMPONENT_HEIGHT,
            } = {},
        } = event;

        switch (messageName) {
            case 'ticketSelectionResize':
                setIframeWrapperHeight(contentHeight);
                break;
            case 'checkoutFormLoaded' || 'orderStart':
                setIsTicketSelectionPage(false);
                break;
            case 'ticketSelectionCompactLoaded':
                setIsTicketSelectionPage(true);
                break;
            default:
                break;
        }
    };

    const _iframeWrapperHeightUnits = isTicketSelectionPage
        ? `${iframeWrapperHeight}px`
        : '100vh';

    const classes = classNames({
        'conversion-bar--ticket-selection': isTicketSelectionPage,
        'conversion-bar--full-size': !isTicketSelectionPage,
    });

    return (
        <div
            id={TICKET_SELECTION_CONTAINER_ID}
            data-testid={TICKET_SELECTION_CONTAINER_ID}
            style={{ height: _iframeWrapperHeightUnits }}
            className={classes}
        ></div>
    );
};
